const FlagIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0102 6.665L8.4002 6.055C8.2552 5.93 8.1702 5.745 8.1652 5.54C8.1552 5.315 8.2452 5.09 8.4102 4.925L9.0102 4.325C9.5302 3.805 9.7252 3.305 9.5602 2.91C9.4002 2.52 8.9052 2.305 8.1752 2.305H2.9502V1.875C2.9502 1.67 2.7802 1.5 2.5752 1.5C2.3702 1.5 2.2002 1.67 2.2002 1.875V11.125C2.2002 11.33 2.3702 11.5 2.5752 11.5C2.7802 11.5 2.9502 11.33 2.9502 11.125V8.685H8.1752C8.8952 8.685 9.3802 8.465 9.5452 8.07C9.7102 7.675 9.5202 7.18 9.0102 6.665Z"
        fill={color ? color : '#0FC44F'}
      />
    </svg>
  );
};

export default FlagIcon;
